import type { Product } from '@/components/Product/ProductCard';
import { toProduct } from './productAdapter';
import type { BestsellerProduct } from './types';

export const BESTSELLER_TRACKING_MODULES = {
  banner: '顶部banner位',
  ranking: '商品榜单版位',
  vibe: '场景商品版位',
} as const;

export interface BestsellerProductTracking {
  trackProductListPitsClick: (
    product: Product,
    index: number,
    moduleName: string,
    tabName?: string,
  ) => void;
  trackProductListPitsExposure: (
    product: Product,
    index: number,
    moduleName: string,
    tabName?: string,
  ) => void;
  trackCollectButtonClick: (
    product: Product,
    index: number,
    moduleName: string,
    collectType: string,
    tabName?: string,
  ) => void;
}

interface CreateBestsellerProductTrackingHandlersOptions {
  tracking: BestsellerProductTracking;
  product: BestsellerProduct;
  index: number;
  moduleName: (typeof BESTSELLER_TRACKING_MODULES)[keyof typeof BESTSELLER_TRACKING_MODULES];
  tabName: string;
}

export function createBestsellerProductTrackingHandlers({
  tracking,
  product,
  index,
  moduleName,
  tabName,
}: CreateBestsellerProductTrackingHandlersOptions) {
  const trackingProduct = toProduct(product);

  return {
    onProductClick: (_productIndex?: number, currentProduct: Product = trackingProduct) =>
      tracking.trackProductListPitsClick(currentProduct, index, moduleName, tabName),
    onProductExposure: (_productIndex?: number, currentProduct: Product = trackingProduct) =>
      tracking.trackProductListPitsExposure(currentProduct, index, moduleName, tabName),
    onCollect: (collectType: '收藏' | '取消收藏', currentProduct: Product = trackingProduct) =>
      tracking.trackCollectButtonClick(currentProduct, index, moduleName, collectType, tabName),
  };
}

export type BestsellerProductTrackingHandlers = ReturnType<
  typeof createBestsellerProductTrackingHandlers
>;
